import { render, staticRenderFns } from "./SideGraphInfo.vue?vue&type=template&id=0df0bd42&scoped=true&"
import script from "./SideGraphInfo.vue?vue&type=script&lang=js&"
export * from "./SideGraphInfo.vue?vue&type=script&lang=js&"
import style0 from "./SideGraphInfo.vue?vue&type=style&index=0&id=0df0bd42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df0bd42",
  null
  
)

export default component.exports